// extracted by mini-css-extract-plugin
export var buttonContainer = "style-module--buttonContainer--1d6f3";
export var history = "style-module--history--d5034";
export var icon = "style-module--icon--a7e09";
export var icons = "style-module--icons--0c79d";
export var label = "style-module--label--7d2f3";
export var left = "style-module--left--fb345";
export var links = "style-module--links--2e540";
export var main = "style-module--main--a9055";
export var menu = "style-module--menu--acfd2";
export var navigationMenu = "style-module--navigationMenu--2a6c3";
export var othersMenu = "style-module--othersMenu--43835";
export var save = "style-module--save--bc09b";
export var sns = "style-module--sns--513b6";